import { CATEGORY_LIST_ACTION } from 'core/constants/Actions'
import { Action } from 'core/models/ActionTypes'
import { ProductCategory } from 'core/models/XoShop'

const intialState: { productCategories: ProductCategory[], count: number, currentPage: number, isLoading: boolean } = {
  productCategories: [],
  isLoading: false,
  count: 0,
  currentPage: 0
}

interface ActionType extends Action {
  payload: {
    productCategories: ProductCategory[];
    count: number;
    currentPage: number;
  }
}

export default function categoryListReducer(state = intialState, action: ActionType) {

  switch (action.type) {
    case CATEGORY_LIST_ACTION.REQUEST:
      return { ...state, isLoading: true }

    case CATEGORY_LIST_ACTION.SUCCESS:
      const { productCategories, count, currentPage } = action.payload;
      return { ...state, productCategories, count, currentPage, isLoading: false }

    case CATEGORY_LIST_ACTION.FAILURE:
      return { ...state, ...intialState }

    default:
      return state
  }
}